/**
 * useDisclosure — 開關狀態的小便利 hook（選用）
 *
 * TermsDialog 是受控元件，狀態仍由消費端持有；此 hook 只是幫你少寫幾行。
 * 用法：
 *   const { open, onOpen, onOpenChange } = useDisclosure();
 *   <button onClick={onOpen}>條款</button>
 *   <TermsDialog open={open} onOpenChange={onOpenChange} siteName={...} />
 */

import { useCallback, useState } from 'react';

export const useDisclosure = (initialOpen = false) => {
  const [open, setOpen] = useState(initialOpen);

  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);
  const onToggle = useCallback(() => setOpen((v) => !v), []);
  const onOpenChange = useCallback((next) => setOpen(!!next), []);

  return { open, setOpen, onOpen, onClose, onToggle, onOpenChange };
};

export default useDisclosure;
